(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vg-category-navigation')) {
    customElements.define('vg-category-navigation', class extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('.vg-category-navigation__cards');
        this.controls = this.querySelector('.vg-category-navigation__controls');
        if (!this.row || !this.controls) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.update = () => {
          const max = this.row.scrollWidth - this.row.clientWidth;
          this.controls.hidden = max < 2;
          this.controls.querySelector('[data-category-direction="-1"]').disabled = this.row.scrollLeft < 2;
          this.controls.querySelector('[data-category-direction="1"]').disabled = this.row.scrollLeft >= max - 2;
        };
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-category-direction]');
          if (!button) return;
          this.row.scrollBy({left: Number(button.dataset.categoryDirection) * this.row.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal});
        this.row.addEventListener('scroll', this.update, {passive: true, signal});
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.row);
        const active = this.row.querySelector('.is-active');
        if (active) this.row.scrollLeft += active.getBoundingClientRect().left - this.row.getBoundingClientRect().left - (this.row.clientWidth - active.clientWidth) / 2;
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-google-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    root.querySelectorAll('[data-vg-google-reviews]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const dialog = section.querySelector('[data-vg-review-dialog]');
      const body = dialog.querySelector('[data-vg-dialog-body]');
      let opener;
      const measure = () => section.querySelectorAll('[data-vg-review-open]').forEach(button => {
        const text = button.closest('[data-vg-review-card]').querySelector('.vg-google-reviews__text');
        button.hidden = text.clientHeight === 0 || text.scrollHeight <= text.clientHeight + 1;
      });
      section.querySelectorAll('[data-vg-review-open]').forEach(button => {
        const card = button.closest('[data-vg-review-card]');
        const text = card.querySelector('.vg-google-reviews__text');
        card.dataset.collapsed = 'true';
        button.addEventListener('click', () => {
          opener = button;
          const copy = card.cloneNode(true);
          copy.removeAttribute('data-collapsed');
          copy.removeAttribute('data-vg-review-card');
          copy.removeAttribute('data-vg-sort');
          copy.querySelectorAll('[data-vg-review-open]').forEach(node => node.remove());
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          body.replaceChildren(copy);
          dialog.showModal();
        });
        if ('ResizeObserver' in window) new ResizeObserver(measure).observe(text);
      });
      dialog.querySelector('[data-vg-dialog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { body.replaceChildren(); opener?.focus({preventScroll: true}); });
      const button = section.querySelector('[data-vg-show-more]');
      if (button) {
        const cards = [...section.querySelectorAll('[data-vg-review-list] [data-vg-review-card]')];
        let shown = 8;
        const update = () => { cards.forEach((card, index) => { card.hidden = index >= shown; }); button.hidden = shown >= cards.length; measure(); };
        button.addEventListener('click', () => { const first = cards[shown]; shown += 8; update(); if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); } });
        update();
      }
      window.addEventListener('resize', measure, {passive: true});
      if (document.fonts) document.fonts.ready.then(measure);
      measure();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-lightweight-whats-new"] && !Shopify.designMode) return;
  try {
    
  function initVgLightWhatsNew(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-vg-light-carousel]');

    carousels.forEach(function (carousel) {
      if (carousel.dataset.vgLightCarouselReady === 'true') return;

      var track = carousel.querySelector('[data-vg-light-carousel-track]');
      var previous = carousel.querySelector('[data-vg-light-carousel-previous]');
      var next = carousel.querySelector('[data-vg-light-carousel-next]');

      if (!track || !previous || !next) return;

      carousel.dataset.vgLightCarouselReady = 'true';

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      function scrollTrack(direction) {
        track.scrollBy({
          left: direction * track.clientWidth * 0.75,
          behavior: 'smooth'
        });
      }

      previous.addEventListener('click', function () {
        scrollTrack(-1);
      });

      next.addEventListener('click', function () {
        scrollTrack(1);
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
      window.setTimeout(updateButtons, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVgLightWhatsNew(document);
    });
  } else {
    initVgLightWhatsNew(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVgLightWhatsNew(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
